import React from "react";
import { Link } from "react-router-dom";
import flags from "../assets/world_flags.png";
import { useSelector } from "react-redux";
import user_avatar from "../assets/user-avatar.svg";

function Mentorbox({ mentor, className }) {
  const { flagsInfo } = useSelector((state) => state.countries);
  const interests = mentor.interests?.map((m) => m.category) || [];
  const isDefault = mentor.profile && !mentor.profile.includes("default");
  const imgHeight = 10;
  const flagPosition = flagsInfo ? flagsInfo[mentor.country] : null;

  return (
    <Link to={`/mentor/${mentor.username}`}>
      <div
        data-testid={`mentor-${mentor.username}`}
        className="relative h-full rounded-lg drop-shadow-[0_4px_30px_rgba(6,6,17,0.06)] bg-pri-tint-4 border border-neutral mentor-wrap"
      >
        {isDefault ? (
          <img
            src={mentor.profile}
            alt=""
            className="w-full h-full object-cover object-center rounded-lg"
          />
        ) : (
          <img
            src={user_avatar}
            alt=""
            className="w-full h-2/3 object-center mx-auto mt-[42px]"
          />
        )}
        <div className="absolute top-0 left-0 bg-black w-full h-full opacity-20"></div>
        <div className="absolute bottom-6 w-full">
          <p className="text-white text-base font-semibold mb-2 capitalize pl-4">
            {mentor.first_name} {mentor.last_name}{" "}
            {flagPosition && (
              <span
                style={{
                  marginLeft: 4,
                  backgroundImage: `url(${flags})`,
                  height: imgHeight,
                  width: 20,
                  backgroundPosition: `0 -${flagPosition * imgHeight}px`,
                  display: "inline-block",
                  backgroundSize: "20px auto",
                }}
              ></span>
            )}
          </p>
          <div className="flex overflow-x-auto gap-2 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
            {interests.map((interest, index) => (
              <div
                className={`${
                  index % 2 ? "bg-[#DD6A57B2]" : "bg-[#5F5FFAB2]"
                } ${
                  index === 0 ? "ml-4" : ""
                } py-1 px-2 rounded-[14px] border-none text-white text-xs leading-[20px] font-semibold flex-shrink-0`}
                key={index}
              >
                {interest}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}

export default Mentorbox;
